import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Tooltip,
  Divider,
  Box,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Pagination,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  Stack,
  useTheme,
  useMediaQuery,
  alpha,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getDashBoardInfo, showToast, WEBSERVICE } from "../../CoreDataService";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector } from "react-redux";
import DataTable from "../../Common/DataTable";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import ModalContent from "../../Common/Modal";
import RollingReservePopup from "../MyWallet/RollingReservePopup";

const WithdrawFundsPage = () => {
  const { userInfo, btncolor } = useSelector((state) => state);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const themeColor = localStorage.getItem("theme");
  const [invoiceList, setInvoiceList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [noOfItemsPerPage] = useState(20);

  const [maxValue, setMaxvalue] = useState("");
  const [minValue, setMinvalue] = useState("");
  const [maxValueAed, setMaxvalueAed] = useState("");
  const [minValueAed, setMinvalueAed] = useState("");
  const [maxValueInr, setMaxvalueInr] = useState("");
  const [minValueInr, setMinvalueInr] = useState("");
  const [maxValueEur, setMaxvalueEur] = useState("");
  const [minValueEur, setMinvalueEur] = useState("");
  const [maxValueSgd, setMaxvalueSgd] = useState("");
  const [minValueSgd, setMinvalueSgd] = useState("");
  const [maxValueGbp, setMaxvalueGbp] = useState("");
  const [minValueGbp, setMinvalueGbp] = useState("");
  const [maxValueCad, setMaxvalueCad] = useState("");
  const [minValueCad, setMinvalueCad] = useState("");
  const [fiatCurrencyList, setFiatCurrencyList] = useState([]);

  const [currencyCode, setCurrencyCode] = useState("");
  const [currencyValue, setCurrencyValue] = useState(0);
  const [currencyId, setCurrencyId] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState("");

  const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);

  const [selectedBank, setSelectedBank] = useState(null);

  const displableOrderNo = "";
  const displableBankName = "";
  const displableAccNo = "";
  const displableRoutingNo = "";
  const displableBeneficiaryName = "";

  const displayableCurrencyCode = "";
  const displableIbanNo = "";
  const displableIfscCode = "";
  const displableAccountType = "";
  const displableBankAddress = "";
  const displableBeneficiaryAddress = "";
  const displableSortCode = "";
  const [showPaymentOrderModal, setShowPaymentOrderModal] = useState(false);

  const [showInvoice, setShowInvoice] = useState(false);
  const invoiceData = null;

  const [twofaModalOpen, setTwofaModalOpen] = useState(false);
  const [emailOtp, setEmailOtp] = useState(null);
  const [twoFactorOtp, setTwoFactorOtp] = useState(null);
  const [isGetCodeButtonDisabled, setIsGetCodeButtonDisabled] = useState(null);
  const [messageOtpSpecific, setMessageOtpSpecific] = useState(null);
  const exist2FaKey = 1;
  const [countdown, setCountdown] = useState(null);
  const [userDetails, setUserDetails] = useState();
  const [rollingReservePopup, setRollingReservePopup] = useState({
    open: false,
    errorMsg: "",
    lockedRollingReserve: 0,
    withdrawableValue: 0,
  });

  const getUserTransaction = async () => {
    try {
      const userTransObj = {
        customerId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
      };

      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) {
        showToast("danger", "Cannot fetch user balance");
        console.log("Fetching User balance failed");
        return;
      }

      const balanceList = result.userBalanceList || [];

      // Set fiat currency list
      const fiatList = balanceList.filter(
        (item) => item.currencyType === "1" || item.currencyType === 1
      );
      setFiatCurrencyList(fiatList);

      // Loop through currency balances
      balanceList.forEach((item) => {
        const { currencyCode, closingBalance } = item;
        switch (currencyCode) {
          case "USD":
            localStorage.setItem("usdbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          case "AED":
            localStorage.setItem("aedbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          case "INR":
            localStorage.setItem("inrbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          case "EUR":
            localStorage.setItem("eurbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          case "SGD":
            localStorage.setItem("sgdbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          case "GBP":
            localStorage.setItem("gbpbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          case "CAD":
            localStorage.setItem("cadbalance", closingBalance);
            setCurrencyCode(currencyCode);
            break;
          default:
            break;
        }
      });

      // Set CURRENCYNAME from helper or constants
      //   setCURRENCYNAME(CURRENCYNAME); // Replace CURRENCYNAME_OBJ with your source

      // Get environment settings from localStorage
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 400) {
        showToast("warning", "Session Timeout. Login Again");
        // logout logic here
      }
    }
  };

  const fetchPaymentOrders = async (page) => {
    try {
      const paymentOrderObj = {
        uuid: localStorage.getItem("uuid"),
        pageNo: page.toString(),
        noOfItemsPerPage: noOfItemsPerPage,
      };

      const response = await axios.post(
        `${WEBSERVICE}transaction/getWithdrawalDetails`,
        JSON.stringify(paymentOrderObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      if (result.error?.error_data === 0) {
        setInvoiceList(result.withdrawalListResult || []);
        setTotalCount(result.totalCount || 0);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        // handle logout
      }
    }
  };

  const getUserBankDetails = async () => {
    try {
      const bankDetailsObj = {
        uuid: localStorage.getItem("uuid"),
      };

      const response = await axios.post(
        `${WEBSERVICE}user/GetUserBankDetails`,
        JSON.stringify(bankDetailsObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", "Error fetching bank details");
      } else {
        const details = result.bankDetails || [];

        setSelectedBank({
          accountNo: details.account_no,
          routingNo: details.routing_no,
          accountType: details.accountType,
          ibanNo: "",
          ifscCode: details.ifscCode,
          swiftCode: details.swiftCode,
          sortCode: "",
          bankAddress: details.bankAddress,
          bankName: details.bank_name,
          beneficiaryName: details.benificiary_name,
          beneficiaryAddress: "",
          bankId: details.bankDetailsId,
          currencyId: "",
        });
        // setAdminBankDetails(details);

        // const formattedBanks = details.map(item => ({
        //     bankname: item.bankName,
        //     bankId: item.bankId,
        // }));
        // setBanks(formattedBanks);
      }
    } catch (error) {
      showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      // logout logic here if needed
    }
  };

  const appSettingsCall = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const infoObj = { uuid };
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserAppSettings`,
        JSON.stringify(infoObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) return;

      // Save user app settings
      localStorage.setItem(
        "user_app_settings_list",
        JSON.stringify(result.userAppSettingsResult)
      );

      // Construct environmentSettingsListObj
      const settingsList = result.settingsList || [];
      const envSettings = {};
      settingsList.forEach((item) => {
        envSettings[`${item.name}${item.currencyId}`] = item;
      });
      localStorage.setItem(
        "environment_settings_list",
        JSON.stringify(envSettings)
      );

      const tierType = userDetails?.userTierType;
      const tierSettings = result.tierWiseTransactionSettingsList || [];

      tierSettings.forEach((item) => {
        if (item.tierType === tierType) {
          switch (item.currencyId) {
            case 1:
              setMaxvalue(item.dailySendLimit);
              setMinvalue(item.minLimit);
              break;
            case 28:
              setMaxvalueAed(item.dailySendLimit);
              setMinvalueAed(item.minLimit);
              break;
            case 35:
              setMaxvalueInr(item.dailySendLimit);
              setMinvalueInr(item.minLimit);
              break;
            case 164:
              setMaxvalueEur(item.dailySendLimit);
              setMinvalueEur(item.minLimit);
              break;
            case 165:
              setMaxvalueSgd(item.dailySendLimit);
              setMinvalueSgd(item.minLimit);
              break;
            case 1878:
              setMaxvalueGbp(item.dailySendLimit);
              setMinvalueGbp(item.minLimit);
              break;
            case 14298:
              setMaxvalueCad(item.dailySendLimit);
              setMinvalueCad(item.minLimit);
              break;
            default:
              break;
          }
        } else {
          // console.log('jkdkdkdkdkdkdddkhdhdh');
        }
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
        // logout logic if needed
      }
    }
  };

  const determineLockStatusForWithdraw = () => {
    // const lockOutgoingTransactionStatus = userAppSettingsObj?.lock_outgoing_transactions;

    // if (lockOutgoingTransactionStatus === 1) {
    //     showToast("error", "You are not eligible to withdraw");
    //     return;
    // }

    const inputval = parseFloat(withdrawAmount); // assume state variable
    const appSettingTierStr = localStorage.getItem(
      "user_app_settings_list_tire"
    );
    const appSettingTierObj = appSettingTierStr
      ? JSON.parse(appSettingTierStr)
      : [];
    const Tiretype = localStorage.getItem("UserTiretype");

    let balance = 0;

    const currencyConfig = {
      USD: { currencyId: 1, balanceKey: "usdbalance" },
      AED: { currencyId: 28, balanceKey: "aedbalance" },
      SGD: { currencyId: 28, balanceKey: "sgdbalance" },
      EUR: { currencyId: 164, balanceKey: "eurbalance" },
      INR: { currencyId: 35, balanceKey: "inrbalance" },
      GBP: { currencyId: 45, balanceKey: "gbpbalance" },
      CAD: { currencyId: 14298, balanceKey: "cadbalance" },
    };

    const config = currencyConfig[currencyCode]; // selectedCurrency is like 'USD', 'AED', etc.

    if (!config) {
      showToast("error", "Unsupported currency");
      return;
    }

    console.log("config", config);

    for (const setting of appSettingTierObj) {
      console.log("setting.currencyId", setting.currencyId);
      console.log("config.currencyId", config.currencyId);
      console.log("setting.tierType", setting.tierType);
      console.log("Tiretype", Tiretype);

      if (
        setting.currencyId === config.currencyId &&
        setting.tierType === parseInt(Tiretype)
      ) {
        console.log("hhhh");

        balance = parseFloat(localStorage.getItem(config.balanceKey) || "0");

        const totalAmount = inputval;

        if (totalAmount <= balance) {
          handleOpenTwoFactorModal();
        } else {
          showToast("error", "Insufficient Funds");
          setWithdrawAmount("");
          setIsWithdrawModalOpen(false);
        }

        break;
      } else {
        console.log("not found");
      }
    }
  };

  // This will open the modal and trigger email code if needed
  const handleOpenTwoFactorModal = () => {
    const twoFactorAuth = localStorage.getItem("twoFactorAuth");

    // Reset OTP fields
    setTwoFactorOtp("");
    // setSmsOtp('');
    setEmailOtp("");

    if (twoFactorAuth === "1" || twoFactorAuth === 1) {
      if (!isGetCodeButtonDisabled) {
        getCodeFromEmail(); // call this method to send the email code
      }

      setTimeout(() => {
        setTwofaModalOpen(true);
      }, 1500);
    } else {
      // setTwofaModalOpen(true)

      showToast(
        "error",
        "Please turn on Two Factor Authentication from Settings first"
      );
    }
  };

  const handleWithdrawFund = async () => {
    const selectedCurrency = currencyCode;
    const amount = parseFloat(withdrawAmount);

    if (!amount || isNaN(amount)) {
      showToast("error", "Please enter a valid withdrawal amount.");
      return;
    }

    if (!emailOtp || !twoFactorOtp) {
      showToast("error", "Please enter both OTPs.");
      return;
    }

    const MIN_MAX = {
      USD: { min: minValue, max: maxValue },
      AED: { min: minValueAed, max: maxValueAed },
      EUR: { min: minValueEur, max: maxValueEur },
      SGD: { min: minValueSgd, max: maxValueSgd },
      GBP: { min: minValueGbp, max: maxValueGbp },
      INR: { min: minValueInr, max: maxValueInr },
      CAD: { min: minValueCad, max: maxValueCad },
    };

    const { min, max } = MIN_MAX[selectedCurrency] || {};

    if (!min || !max) {
      showToast("error", `Unsupported currency: ${selectedCurrency}`);
      return;
    }

    if (amount < min) {
      showToast(
        "error",
        `Minimum withdrawal amount is ${min} ${selectedCurrency}.`
      );
      return;
    }

    if (amount > max) {
      showToast(
        "error",
        `Maximum withdrawal amount is ${max} ${selectedCurrency}.`
      );
      return;
    }

    // Disable withdraw button
    // setWithdrawLoading(true);

    const payload = {
      uuid: localStorage.getItem("uuid"),
      otp: emailOtp,
      phoneOtp: "",
      securityCode: twoFactorOtp,
      sendAmount: withdrawAmount,
      currencyId: currencyId,
      userBankId: selectedBank.bankId,
    };

    console.log("payload", payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/createWithdrawalOrder`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast(
          "success",
          response.data.error.error_msg || "Withdrawal successful."
        );
        // Optionally refresh or reset state
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (response.data.error.error_data === 3) {
        setTwofaModalOpen(false);
        setRollingReservePopup({
          open: true,
          errorMsg: response.data.error.error_msg || "",
          lockedRollingReserve: response.data.lockedRollingReserveValue ?? 0,
          withdrawableValue: response.data.withdrawableValue ?? 0,
        });
      } else {
        showToast(
          "error",
          response.data.error.error_msg || "Withdrawal failed."
        );
      }
    } catch (error) {
      console.error("Withdrawal error:", error);
      showToast(
        "error",
        error?.response?.data?.message ||
          "Something went wrong during withdrawal."
      );
    } finally {
      // setWithdrawLoading(false);
    }
  };

  const handlePageChange = (_, newPage) => {
    setPageNo(newPage);
    fetchPaymentOrders(newPage);
  };

  useEffect(() => {
    getDashBoardInfo();
    fetchPaymentOrders(pageNo);
    getUserBankDetails();
    getUserDetails();
    getUserTransaction();
  }, []);

  useEffect(() => {
    if (userDetails) {
      appSettingsCall();
    }
  }, [userDetails]);

  const getUserDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");
    const userId = localStorage.getItem("userId");
    const data = {
      userId: userId,
      uuid: uuid,
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/GetUserDetails`,
        data,
        {
          headers: {
            Authorization: `BEARER ${token}`, // Include the token in the Authorization header
          },
        }
      );
      setUserDetails(response?.data?.userResult);
    } catch (err) {
      showToast("error", err?.response?.data?.error?.error_msg);
    }
  };

  const getWithdrawModal = (elem, bal, cId) => {
    if (userInfo.userResult.isFiatWithdraw !== 1) {
      showToast("error", "Withdraw operation is restricted in your account");
    } else {
      console.log(elem, bal, cId);

      setCurrencyCode(elem);
      setCurrencyValue(bal);
      setCurrencyId(cId);
      localStorage.setItem("currencyId", cId);
      setIsWithdrawModalOpen(true);
    }
  };

  const isWithdrawDisabled = () => {
    const amount = parseFloat(withdrawAmount);
    if (!amount || isNaN(amount)) return true;

    switch (currencyCode) {
      case "USD":
        return amount < minValue || amount > maxValue;
      case "AED":
        return amount < minValueAed || amount > maxValueAed;
      case "INR":
        return amount < minValueInr || amount > maxValueInr;
      case "EUR":
        return amount < minValueEur || amount > maxValueEur;
      case "SGD":
        return amount < minValueSgd || amount > maxValueSgd;
      case "GBP":
        return amount < minValueGbp || amount > maxValueGbp;
      case "CAD":
        return amount < minValueCad || amount > maxValueCad;
      default:
        return true;
    }
  };

  // const selectedBank = selectedCurrency ? bankDetails[selectedCurrency] : null;

  const getCodeFromEmail = async () => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/ResendOTP/withdraw`,
        { email: localStorage.getItem("email") },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast("success", "OTP Sent Successfully to Registered Email Id");
        setMessageOtpSpecific(
          `Enter the 8-digit code received by ${localStorage.getItem("email")}`
        );
        startCountdown(300);
      }
    } catch (error) {
      alert("SESSION TIMED OUT. LOGIN AGAIN");
    }
  };

  const startCountdown = (duration) => {
    setIsGetCodeButtonDisabled(true);
    setCountdown(duration);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsGetCodeButtonDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const BankDetail = ({ label, value }) => (
    <Box sx={modernBankDetailRow}>
      <Typography sx={bankDetailLabel}>{label}</Typography>
      <Box sx={bankDetailValueWrap}>
        <Typography sx={bankDetailValue}>{value}</Typography>
        {value && (
          <Tooltip title="Copy" arrow>
            <IconButton
              size="small"
              sx={bankDetailCopyBtn}
              onClick={() => navigator.clipboard.writeText(value)}
            >
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );

  return (
    <Box sx={pageWrapper}>
      {/* Hero Banner */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <AccountBalanceWalletOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Withdraw Funds</Typography>
            <Typography sx={heroSubtitle}>
              Withdraw fiat currency from your wallet directly to your linked bank account
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Fiat Balances + Bank Details */}
      <Box sx={panelsGrid}>
        {/* Fiat Balances Panel */}
        <Box sx={panelCard}>
          <Box sx={panelHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <Box sx={{ ...panelIconWrap, backgroundColor: `${btncolor}1a`, color: btncolor }}>
                <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 20 }} />
              </Box>
              <Box>
                <Typography sx={panelTitle}>Fiat Balances</Typography>
                <Typography sx={panelCaption}>Click Withdraw to initiate a withdrawal</Typography>
              </Box>
            </Box>
            <Tooltip title="The user can withdraw the amount, which will then be credited to the bank account provided in the Bank Info menu." arrow>
              <InfoOutlinedIcon sx={infoIconStyle} />
            </Tooltip>
          </Box>
          <Box sx={panelDivider} />

          <Box sx={fiatTableHead}>
            <Typography sx={fiatHeadCell}>Currency</Typography>
            <Typography sx={fiatHeadCell}>Balance</Typography>
            <Typography sx={{ ...fiatHeadCell, textAlign: "right" }}>Action</Typography>
          </Box>

          <Stack spacing={1}>
            {fiatCurrencyList.map((bal, i) => (
              <Box key={i} sx={fiatRow}>
                <Box sx={fiatCellLeft}>
                  <Box sx={{ ...currencyAvatar, backgroundColor: `${btncolor}1a`, color: btncolor }}>
                    {(bal.currencyCode || "").slice(0, 1)}
                  </Box>
                  <Typography sx={currencyCodeText}>{bal.currencyCode}</Typography>
                </Box>
                <Typography sx={balanceText}>{bal.closingBalance}</Typography>
                <Box sx={fiatActionCell}>
                  {bal.disabledWithdrawByCountry == 0 ? (
                    <ContainedButton
                      variant="contained"
                      size="small"
                      sx={withdrawActionBtn}
                      onClick={() => getWithdrawModal(bal.currencyCode, bal.closingBalance, bal.currencyId)}
                    >
                      Withdraw
                    </ContainedButton>
                  ) : (
                    <OutlinedButton variant="outlined" size="small" disabled sx={restrictedBtn}>
                      Restricted
                    </OutlinedButton>
                  )}
                </Box>
              </Box>
            ))}
            {fiatCurrencyList.length === 0 && (
              <Box sx={emptyState}>
                <InboxOutlinedIcon sx={emptyIcon} />
                <Typography sx={emptyText}>No currencies available</Typography>
              </Box>
            )}
          </Stack>
        </Box>

        {/* Bank Details Panel */}
        <Box sx={panelCard}>
          <Box sx={panelHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <Box sx={{ ...panelIconWrap, backgroundColor: `${btncolor}1a`, color: btncolor }}>
                <AccountBalanceOutlinedIcon sx={{ fontSize: 20 }} />
              </Box>
              <Box>
                <Typography sx={panelTitle}>Bank Details</Typography>
                <Typography sx={panelCaption}>Withdrawal will be credited to this account</Typography>
              </Box>
            </Box>
            <Tooltip title="Funds withdrawal will be processed to the below mentioned bank account." arrow>
              <InfoOutlinedIcon sx={infoIconStyle} />
            </Tooltip>
          </Box>
          <Box sx={panelDivider} />

          {selectedBank ? (
            <Stack spacing={1}>
              <BankDetail label="Account Holder" value={selectedBank.beneficiaryName} />
              <BankDetail label="Bank Account No" value={selectedBank.accountNo} />
              <BankDetail label="Account Type" value={selectedBank.accountType} />
              <BankDetail label="Bank Name" value={selectedBank.bankName} />
              <BankDetail label="Bank Address" value={selectedBank.bankAddress} />
              {selectedBank.ifscCode && <BankDetail label="Bank IFSC Code" value={selectedBank.ifscCode} />}
              {selectedBank.swiftCode && <BankDetail label="Bank Swift Code" value={selectedBank.swiftCode} />}
              {selectedBank.routingNo && <BankDetail label="Bank Routing No" value={selectedBank.routingNo} />}
              {selectedBank.ibanNo && <BankDetail label="Bank Iban No" value={selectedBank.ibanNo} />}
            </Stack>
          ) : (
            <Box sx={emptyState}>
              <AccountBalanceOutlinedIcon sx={emptyIcon} />
              <Typography sx={emptyText}>Bank data is loading. Please wait...</Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Withdraw History */}
      <Box sx={historyCard}>
        <Box sx={panelHeader}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <Box sx={{ ...panelIconWrap, backgroundColor: `${btncolor}1a`, color: btncolor }}>
              <HistoryOutlinedIcon sx={{ fontSize: 20 }} />
            </Box>
            <Box>
              <Typography sx={panelTitle}>Withdraw History</Typography>
              <Typography sx={panelCaption}>Your past withdrawal orders and statuses</Typography>
            </Box>
          </Box>
          <Tooltip title="Displays date, withdrawal id, currency, debited amount, transaction charge and status of your withdrawal orders" arrow>
            <InfoOutlinedIcon sx={infoIconStyle} />
          </Tooltip>
        </Box>
        <Box sx={panelDivider} />

        <DataTable
          columns={["Date", "Withdrawal Id", "Currency", "Debited Amount", "Transaction Charge", "Withdrawal Credit", "Status"]}
        >
          {invoiceList.map((i, index) => (
            <TableRow key={index} sx={modernTableRow}>
              <TableCell sx={modernCell}>{i.timestamp}</TableCell>
              <TableCell sx={modernCell}>{i.withdrawalId}</TableCell>
              <TableCell sx={modernCell}>{i.currency}</TableCell>
              <TableCell sx={modernCell}>{i.amount}</TableCell>
              <TableCell sx={modernCell}>{i.txnCharge}</TableCell>
              <TableCell sx={modernCell}>{i.amount - i.txnCharge}</TableCell>
              <TableCell sx={modernCell}>
                <Box sx={{
                  ...statusBadge,
                  color: i.status === "Confirmed" ? "#16a34a" : i.status === "Declined" ? "#dc2626" : "#d97706",
                  backgroundColor: i.status === "Confirmed" ? "rgba(22,163,74,0.10)" : i.status === "Declined" ? "rgba(220,38,38,0.10)" : "rgba(217,119,6,0.10)",
                  borderColor: i.status === "Confirmed" ? "rgba(22,163,74,0.25)" : i.status === "Declined" ? "rgba(220,38,38,0.25)" : "rgba(217,119,6,0.25)",
                }}>
                  {i.status}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </DataTable>

        {totalCount > noOfItemsPerPage && (
          <Box sx={paginationWrap}>
            <Pagination
              count={Math.ceil(totalCount / noOfItemsPerPage)}
              page={pageNo}
              onChange={handlePageChange}
              sx={paginationStyle}
            />
          </Box>
        )}
      </Box>

      {/* Withdraw Modal */}
      <ModalContent
        open={isWithdrawModalOpen}
        onClose={() => setIsWithdrawModalOpen(false)}
        title="Withdraw Funds"
        width="xs"
      >
        <Box sx={depositModalBalance}>
          <Typography sx={depositModalLabel}>Current {currencyCode} Balance</Typography>
          <Typography sx={depositModalValue}>
            {currencyCode === "USD" && `$${currencyValue}`}
            {currencyCode === "AED" && `د.إ${currencyValue}`}
            {currencyCode === "INR" && `₹${currencyValue}`}
            {currencyCode === "EUR" && `€${currencyValue}`}
            {currencyCode === "SGD" && `S$${currencyValue}`}
            {currencyCode === "GBP" && `£${currencyValue}`}
            {currencyCode === "CAD" && `C$${currencyValue}`}
          </Typography>
        </Box>

        <TextField
          type="number"
          value={withdrawAmount}
          onChange={(e) => setWithdrawAmount(e.target.value)}
          label="Enter Withdrawal Amount"
          fullWidth
          variant="outlined"
          sx={modernModalField}
        />

        <Box sx={limitInfoBox}>
          <InfoOutlinedIcon sx={{ fontSize: 14, opacity: 0.7 }} />
          <Typography sx={limitInfoText}>
            {currencyCode === "USD" && `Minimum $${minValue} • Maximum $${maxValue}`}
            {currencyCode === "AED" && `Minimum د.إ${minValueAed} • Maximum د.إ${maxValueAed}`}
            {currencyCode === "INR" && `Minimum ₹${minValueInr} • Maximum ₹${maxValueInr}`}
            {currencyCode === "EUR" && `Minimum €${minValueEur} • Maximum €${maxValueEur}`}
            {currencyCode === "SGD" && `Minimum S$${minValueSgd} • Maximum S$${maxValueSgd}`}
            {currencyCode === "GBP" && `Minimum £${minValueGbp} • Maximum £${maxValueGbp}`}
            {currencyCode === "CAD" && `Minimum C$${minValueCad} • Maximum C$${maxValueCad}`}
          </Typography>
        </Box>

        <ContainedButton
          variant="contained"
          fullWidth
          sx={modernModalPrimaryBtn}
          disabled={isWithdrawDisabled()}
          onClick={determineLockStatusForWithdraw}
        >
          WITHDRAW
        </ContainedButton>
      </ModalContent>

      {/* Payment Order Modal */}
      <Dialog
        open={showPaymentOrderModal}
        onClose={() => setShowPaymentOrderModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: modernDialogPaper }}
      >
        <DialogTitle sx={modernDialogTitle}>
          <Typography sx={dialogTitleText}>Payment Order</Typography>
          <IconButton onClick={() => setShowPaymentOrderModal(false)} size="small" sx={dialogCloseBtn}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={modernDialogContent}>
          <Box sx={orderNoBlock}>
            <Typography sx={orderNoLabel}>Order No</Typography>
            <Typography sx={{ ...orderNoValue, color: btncolor }}>{displableOrderNo}</Typography>
            <Typography sx={orderNoHint}>Please complete the transfer within 72 hours to the account below.</Typography>
          </Box>

          <Stack spacing={1.25} sx={{ mt: 2 }}>
            {[
              { label: "Beneficiary Name", value: displableBeneficiaryName },
              { label: "Beneficiary Address", value: displableBeneficiaryAddress },
              { label: "Bank Account No", value: displableAccNo },
              { label: "Account Type", value: displableAccountType },
              { label: "Sort Code", value: displableSortCode },
              { label: "Bank Name", value: displableBankName },
              { label: "Bank Address", value: displableBankAddress },
              { label: "Routing No", value: displableRoutingNo },
              { label: "IBAN", value: displableIbanNo },
              { label: "IFSC", value: displableIfscCode },
            ].filter(item => item.value).map((item, index) => (
              <Box key={index} sx={modernInvoiceRow}>
                <Typography sx={invoiceRowLabel}>{item.label}</Typography>
                <Typography sx={invoiceRowValue}>{item.value}</Typography>
              </Box>
            ))}
          </Stack>

          <Box sx={noticeBlock}>
            <Typography sx={noticeText}><strong>*</strong> Please include <strong>only</strong> the <strong>order number</strong> in the payment reference field.</Typography>
            <Typography sx={noticeText}><strong>*</strong> The request will expire in <strong>72 hours.</strong></Typography>
            <Typography sx={noticeText}><strong>*</strong> The <strong>name</strong> and <strong>account number</strong> for the transfer should match details given on the website.</Typography>
            {currencyCode === "INR" ? (
              <Typography sx={noticeText}><strong>*</strong> All transactions with incorrect details will be refunded in 15 business days after deducting processing fees.</Typography>
            ) : (
              <Typography sx={noticeText}><strong>*</strong> All transactions with incorrect details will be refunded in 15 business days after deducting {displayableCurrencyCode} 15 towards processing fees.</Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
            <ContainedButton variant="contained" onClick={() => setShowPaymentOrderModal(false)} sx={modernModalPrimaryBtn}>
              OK
            </ContainedButton>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Invoice Dialog */}
      {showInvoice && invoiceData && (
        <Dialog open={showInvoice} onClose={() => setShowInvoice(false)} fullWidth maxWidth="xs" PaperProps={{ sx: modernDialogPaper }}>
          <DialogTitle sx={modernDialogTitle}>
            <Typography sx={dialogTitleText}>Invoice</Typography>
            <IconButton onClick={() => setShowInvoice(false)} size="small" sx={dialogCloseBtn}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={modernDialogContent}>
            <Stack spacing={1.25}>
              <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Order No</Typography><Typography sx={invoiceRowValue}>{invoiceData?.invoiceOrderNoI}</Typography></Box>
              <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Amount</Typography><Typography sx={invoiceRowValue}>{invoiceData?.invoiceAmountI} {invoiceData?.currencynameI}</Typography></Box>
              <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Bank Name</Typography><Typography sx={invoiceRowValue}>{invoiceData?.bankNameI}</Typography></Box>
              <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Account No</Typography><Typography sx={invoiceRowValue}>{invoiceData?.accountNoI}</Typography></Box>
              <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Beneficiary Name</Typography><Typography sx={invoiceRowValue}>{invoiceData?.beneficiaryNameI}</Typography></Box>
              <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Account Type</Typography><Typography sx={invoiceRowValue}>{invoiceData?.accountTypeI}</Typography></Box>
              {invoiceData?.routingNoI && <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Routing No</Typography><Typography sx={invoiceRowValue}>{invoiceData.routingNoI}</Typography></Box>}
              {invoiceData?.ibanNoI && <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>IBAN</Typography><Typography sx={invoiceRowValue}>{invoiceData.ibanNoI}</Typography></Box>}
              {invoiceData?.ifscCodeI && <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>IFSC</Typography><Typography sx={invoiceRowValue}>{invoiceData.ifscCodeI}</Typography></Box>}
              {invoiceData?.sortCodeI && <Box sx={modernInvoiceRow}><Typography sx={invoiceRowLabel}>Sort Code</Typography><Typography sx={invoiceRowValue}>{invoiceData.sortCodeI}</Typography></Box>}
            </Stack>
          </DialogContent>
          <DialogActions sx={modernDialogActions}>
            <ContainedButton variant="contained" onClick={() => setShowInvoice(false)} sx={modernModalPrimaryBtn}>OK</ContainedButton>
          </DialogActions>
        </Dialog>
      )}

      {/* Rolling Reserve Popup */}
      <RollingReservePopup
        open={rollingReservePopup.open}
        onClose={() => setRollingReservePopup((prev) => ({ ...prev, open: false }))}
        errorMsg={rollingReservePopup.errorMsg}
        lockedRollingReserve={rollingReservePopup.lockedRollingReserve}
        withdrawableValue={rollingReservePopup.withdrawableValue}
        theme={themeColor === "dark" ? "dark" : "light"}
      />

      {/* 2FA Modal */}
      <Dialog open={twofaModalOpen} onClose={() => setTwofaModalOpen(false)} maxWidth="sm" fullWidth PaperProps={{ sx: modernDialogPaper }}>
        <DialogTitle sx={modernDialogTitle}>
          <Typography sx={dialogTitleText}>Security Authentication</Typography>
          <IconButton onClick={() => setTwofaModalOpen(false)} size="small" sx={dialogCloseBtn}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ ...modernDialogContent, pt: 2 }}>
          <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)", opacity: 0.75, mb: 1.5 }}>
            Input OTP from your registered email address
          </Typography>
          <Box display="flex" gap={2} mb={2}>
            <TextField
              fullWidth
              variant="outlined"
              label="OTP"
              type="password"
              value={emailOtp}
              onChange={(e) => setEmailOtp(e.target.value)}
              sx={modernModalField}
            />
            <ContainedButton
              variant="contained"
              onClick={() => getCodeFromEmail()}
              disabled={isGetCodeButtonDisabled}
              sx={{ height: 48, borderRadius: "10px", textTransform: "none", fontWeight: 600, whiteSpace: "nowrap" }}
            >
              {isGetCodeButtonDisabled ? `Resend in ${countdown}s` : "Get Code"}
            </ContainedButton>
          </Box>
          {messageOtpSpecific && (
            <Typography sx={{ fontSize: "0.82rem", color: "#ef4444", mb: 1.5 }}>{messageOtpSpecific}</Typography>
          )}
          {(exist2FaKey === "1" || exist2FaKey === 1) && (
            <>
              <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)", opacity: 0.75, mb: 1 }}>
                Input OTP from your Google Authenticator
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                label="Two-Factor Authenticator Code"
                type="password"
                value={twoFactorOtp}
                onChange={(e) => setTwoFactorOtp(e.target.value)}
                sx={modernModalField}
              />
            </>
          )}
        </DialogContent>
        <DialogActions sx={modernDialogActions}>
          <ContainedButton
            variant="contained"
            disabled={!emailOtp || (exist2FaKey === 1 && !twoFactorOtp)}
            onClick={() => handleWithdrawFund()}
            sx={modernModalPrimaryBtn}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// ── Styles ─────────────────────────────────────────────────────────────────────
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const panelsGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
  gap: 2.5,
  mb: 3,
};

const panelCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 6px 18px rgba(0,0,0,0.04)",
  p: { xs: 2.25, md: 2.75 },
  display: "flex",
  flexDirection: "column",
};

const panelHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

const panelIconWrap = {
  width: 38,
  height: 38,
  borderRadius: "11px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const panelTitle = {
  fontSize: "1.05rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const panelCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.65,
  mt: 0.25,
};

const panelDivider = {
  height: "1px",
  backgroundColor: "rgba(125,125,125,0.15)",
  my: 2,
};

const infoIconStyle = {
  fontSize: 18,
  color: "var(--text-color)",
  opacity: 0.5,
  cursor: "help",
};

const fiatTableHead = {
  display: "grid",
  gridTemplateColumns: "1.2fr 1fr 1.2fr",
  alignItems: "center",
  px: 1.5,
  pb: 1,
};

const fiatHeadCell = {
  fontSize: "0.7rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.65,
};

const fiatRow = {
  display: "grid",
  gridTemplateColumns: "1.2fr 1fr 1.2fr",
  alignItems: "center",
  px: 1.5,
  py: 1.25,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.10)",
  transition: "all 0.15s ease",
  "&:hover": {
    borderColor: "rgba(125,125,125,0.20)",
    transform: "translateY(-1px)",
  },
};

const fiatCellLeft = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
};

const currencyAvatar = {
  width: 32,
  height: 32,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: "0.85rem",
  flexShrink: 0,
};

const currencyCodeText = {
  fontSize: "0.9rem",
  fontWeight: 600,
  color: "var(--text-color)",
};

const balanceText = {
  fontSize: "0.9rem",
  fontWeight: 600,
  color: "var(--text-color)",
};

const fiatActionCell = {
  display: "flex",
  justifyContent: "flex-end",
};

const withdrawActionBtn = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.78rem",
  px: 2,
  height: 34,
  borderRadius: "9px",
  whiteSpace: "nowrap",
};

const restrictedBtn = {
  textTransform: "none",
  fontSize: "0.72rem",
  height: 34,
  borderRadius: "9px",
  whiteSpace: "nowrap",
};

const modernBankDetailRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  px: 1.5,
  py: 1.1,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.10)",
};

const bankDetailLabel = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const bankDetailValueWrap = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  minWidth: 0,
  flex: 1,
  justifyContent: "flex-end",
};

const bankDetailValue = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textAlign: "right",
  wordBreak: "break-word",
};

const bankDetailCopyBtn = {
  color: "var(--text-color)",
  opacity: 0.5,
  flexShrink: 0,
  "&:hover": { opacity: 1, backgroundColor: "rgba(125,125,125,0.10)" },
};

const historyCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 6px 18px rgba(0,0,0,0.04)",
  p: { xs: 2.25, md: 2.75 },
};

const modernTableRow = {
  backgroundColor: "var(--body-color-less)",
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
};

const modernCell = {
  fontSize: "0.85rem",
  py: 1.5,
  color: "var(--text-color)",
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};

const statusBadge = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  px: 1.1,
  py: 0.4,
  borderRadius: "999px",
  border: "1px solid",
  fontSize: "0.72rem",
  fontWeight: 700,
  letterSpacing: "0.02em",
};

const emptyState = {
  textAlign: "center",
  py: 5,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1,
};

const emptyIcon = {
  fontSize: 44,
  color: "var(--text-color)",
  opacity: 0.35,
};

const emptyText = {
  fontSize: "0.88rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

const paginationWrap = {
  display: "flex",
  justifyContent: "center",
  mt: 2.5,
};

const paginationStyle = {
  "& .MuiPaginationItem-root": {
    color: "var(--text-color)",
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .Mui-selected": {
    backgroundColor: "rgba(125,125,125,0.18) !important",
  },
};

const modernDialogPaper = {
  borderRadius: "16px",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
};

const modernDialogTitle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 3,
  py: 2,
  backgroundColor: "var(--popupheader-color)",
  borderBottom: "1px solid rgba(125,125,125,0.15)",
};

const dialogTitleText = {
  fontSize: "1.1rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const dialogCloseBtn = {
  color: "var(--text-color)",
  opacity: 0.7,
  "&:hover": { opacity: 1, backgroundColor: "rgba(125,125,125,0.10)" },
};

const modernDialogContent = {
  px: 3,
  py: 3,
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const modernDialogActions = {
  justifyContent: "center",
  px: 3,
  pb: 3,
  pt: 0,
  backgroundColor: "var(--popupbody-color)",
};

const depositModalBalance = {
  textAlign: "center",
  py: 2,
  px: 2,
  mb: 2,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.15)",
};

const depositModalLabel = {
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
};

const depositModalValue = {
  fontSize: "1.5rem",
  fontWeight: 700,
  color: "var(--text-color)",
  mt: 0.5,
};

const modernModalField = {
  mb: 1.5,
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
};

const limitInfoBox = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
  px: 1.5,
  py: 1,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  mb: 2,
};

const limitInfoText = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.8,
};

const modernModalPrimaryBtn = {
  py: 1.3,
  px: 4,
  borderRadius: "10px",
  fontWeight: 700,
  fontSize: "0.88rem",
  textTransform: "none",
  minWidth: 200,
};

const orderNoBlock = {
  textAlign: "center",
  py: 2,
  px: 2,
  borderRadius: "12px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.15)",
};

const orderNoLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.7,
};

const orderNoValue = {
  fontSize: "1.4rem",
  fontWeight: 800,
  letterSpacing: "0.02em",
  mt: 0.5,
  wordBreak: "break-all",
};

const orderNoHint = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.7,
  mt: 1,
};

const modernInvoiceRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  px: 1.5,
  py: 1.1,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.10)",
  width: "100%",
};

const invoiceRowLabel = {
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.7,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const invoiceRowValue = {
  fontSize: "0.88rem",
  fontWeight: 700,
  color: "var(--text-color)",
  textAlign: "right",
  wordBreak: "break-word",
  flex: 1,
};

const noticeBlock = {
  mt: 3,
  p: 2,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.12)",
};

const noticeText = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.85,
  lineHeight: 1.55,
  mb: 0.75,
  "&:last-child": { mb: 0 },
};

export default WithdrawFundsPage;
